// @ts-nocheck -- see CLAUDE.md's "TypeScript checking on assets/*.js" section for why
(function () {
  window.OXTAK_I18N = window.OXTAK_I18N || {};
  var OXH_HOME_I18N = window.OXH_HOME_I18N;
  Object.keys(OXH_HOME_I18N).forEach(function (code) {
    window.OXTAK_I18N[code] = window.OXTAK_I18N[code] || {};
    window.OXTAK_I18N[code].home = OXH_HOME_I18N[code];
  });

  // Shopify's native "text" block setting sanitizes its rich-text HTML and rejects any
  // data-i18n* attribute placed directly on the heading/paragraph content (confirmed via
  // a real Upload Errors response: "Attribute 'data-i18n-html=...' is not permitted on
  // tag '<p>'"), so the hero heading and about-page paragraph -- both native "text"
  // blocks, not custom_liquid -- can't use the normal data-i18n-html mechanism. Instead,
  // target Shopify's own auto-generated `text-block--{hash}__{block-id}` wrapper class,
  // which sits outside the sanitized setting value and is stable since the suffix is
  // literally our own block id from templates/index.json, not Shopify-generated
  // randomness.
  function localizeHomeBlocks(code) {
    var i18n = window.OXTAK_I18N || {};
    var dict = (i18n[code] && i18n[code].home) || (i18n.en && i18n.en.home);
    if (!dict) return;
    var hero = document.querySelector('[class*="__text_edY6A6"] h3');
    if (hero && dict.hero) {
      hero.innerHTML = window.oxtakEscapeHtml(dict.hero.heading).replace(/\n/g, '<br>');
    }
    var about = document.querySelector('[class*="__text_xHyXVx"] p');
    if (about && dict.about) {
      about.innerHTML = window.oxtakEscapeHtml(dict.about.body).replace(/\n/g, '<br>');
    }
  }

  localizeHomeBlocks(window.getOxtakLocale());
  document.addEventListener('oxtak:locale-applied', function (event) {
    localizeHomeBlocks(event.detail.code);
  });

  window.applyLocale(window.getOxtakLocale());
})();
